module.exports = __webpack_public_path__ + "static/media/instagram.ba310578.svg";